import { Observable } from '@reactivex/rxjs';
import { scaleUtc, scalePow, scaleLinear } from 'd3-scale';

import hoistStatics from 'react-recompose/hoistStatics';
import mapPropsStream from 'react-recompose/mapPropsStream';

export const withTimeScale = hoistStatics(
    mapPropsStream(props => {
        return Observable.from(props)
            .filter(({ width, height }) => (
                width && width > 0 &&
                height && height > 0
            ))
            .scan(scanPropsWithTimeScale, {})
            .pluck('props');
    })
);

export const withValueScale = hoistStatics(
    mapPropsStream(props => {
        return Observable.from(props)
            .scan(scanPropsWithValueScale, {})
            .pluck('props');
    })
);

function scanPropsWithTimeScale(memo, props) {
    let { minValue, maxValue } = props;
    let { minTime = minValue, maxTime = maxValue } = props;
    let { timeScale, zoomScale, timeDomain, zoomDomain } = memo;
    if (minTime !== undefined && maxTime !== undefined) {
        let shouldUpdate = !(timeScale && memo.minTime === minTime && memo.maxTime === maxTime);
        if (shouldUpdate) {
            timeScale = scaleUtc().domain(timeDomain = [minTime, maxTime]).clamp(true);
            zoomScale = scaleUtc().domain(zoomDomain = [minTime, maxTime]).clamp(true);
        }
    }

    return {
        ...memo,
        minTime, maxTime,
        timeScale, timeDomain,
        zoomScale, zoomDomain,
        props: {
            ...props,
            minTime, maxTime,
            timeScale, timeDomain,
            zoomScale, zoomDomain,
        }
    };
}

function scanPropsWithValueScale(memo, props) {
    let { min, max } = props;
    let { valueScale, valueDomain } = memo;
    let pow = Math.max(props.pow || 0.5, 0.5) || 0.5;
    let scaleType = props.scaleType || memo.scaleType || 'pow';
    if (min !== undefined && max !== undefined) {
        let shouldUpdate = !(memo.min === min && memo.max === max && memo.scaleType === scaleType);
        if (scaleType === 'pow' && !shouldUpdate) {
            shouldUpdate = memo.pow !== pow;
        }
        if (shouldUpdate) {
            if (scaleType === 'linear') {
                max = Math.max(0, max);
                min = Math.max(0, min);
                valueScale = scaleLinear().domain(valueDomain = [0, max]);
            } else {
                max = Math.max(0, max);
                min = Math.max(0, min);
                valueScale = scalePow().domain(valueDomain = [0, max]).exponent(pow);
            }
        }
    }

    return {
        ...memo, min, max, pow,
        scaleType, valueScale, valueDomain,
        props: { ...props, min, max, valueScale, valueDomain }
    };
}
